module.exports = __webpack_public_path__ + "img/iPhone4@2x.2f05ee19.png";